"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterSuppliesDataFromDate = void 0;
var moment_1 = __importDefault(require("moment"));
function filterSuppliesDataFromDate(suppliesData, date) {
    return suppliesData.map(function (_a) {
        var ARKTCOMART = _a.ARKTCOMART, supplies = _a.supplies;
        var index = supplies.findIndex(function (_a) {
            var dateToCompare = _a.dateToCompare;
            return moment_1.default(dateToCompare).isSame(date, "day");
        });
        return {
            ARKTCOMART: ARKTCOMART,
            supplies: supplies.slice(index),
        };
    });
}
exports.filterSuppliesDataFromDate = filterSuppliesDataFromDate;
